import { DropdownMenuItem } from "@snap-mobile/snap-ui/dist/types/utils";

export const tabs: DropdownMenuItem[] = [
  { name: "Transactions", text: "", value: "", selected: true },
  { name: "Pending Checks", text: "", value: "", selected: false },
  { name: "Statements", text: "", value: "", selected: false },
];
